module.exports = __webpack_public_path__ + "img/arrow-long-left.46e2c7cb.svg";